import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Form, Select, TimePicker, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { createCalendarEntry } from './calendarEntry.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { getProfesseurs } from '../personnel/personnel.reducer';
import { getEntities } from '../matiere-ecole/matiere-ecole.reducer';
import { JourSemaine } from './calendar-constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import './calendar-entry-modal.scss';

export const CalendarEntryCreateModal = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();

  const currentEcole = useAppSelector(state => state.ecole.entity);
  const classeid = props.match.params.id;
  const matieres = useAppSelector(state => state.matiereEcole.entities);
  const professeurs = useAppSelector(state => state.professeur.entities);
  const [heureDebut, setHeureDebut] = useState('07:00');
  const [heureFin, setHeureFin] = useState('10:00');
  const [selectedProfesseurs, setSelectedProfesseurs] = useState([]);

  const handleTimeChange = (times, timeStrings) => {
    if (times && times.length === 2) {
      setHeureDebut(timeStrings[0]);
      setHeureFin(timeStrings[1]);
    }
  };

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getEntities({ ecoleId: props.match.params.ecoleid, page: 0, size: 100 }));
    dispatch(getProfesseurs({ ecoleId: props.match.params.ecoleid, page: 0, size: 100, typePersonnel: 'ENSEIGNANT' }));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/calendar/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}/${classeid}/calendarEntry`);
  };

  const saveEntity = async values => {
    const entity = {
      ...values,
      classeId: props.match.params.id,
      anneeScolaireId: props.match.params.anneeScolaireId,
      professeurs: selectedProfesseurs,
      heureDebut,
      heureFin,
    };
    try {
      const response = await dispatch(createCalendarEntry(entity));
      if (createCalendarEntry.rejected.match(response)) {
        return;
      }

      handleClose(event);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement:", error);
    }
  };

  const goBack = () => {
    props.history.goBack();
  };

  const handleProfesseur = data => {
    setSelectedProfesseurs(data.map(p => ({ id: p })));
  };

  return (
    <>
      <Modal title="Ajouter une entrée" className="calendar-entry-modal" centered footer={null} visible={true} closable={false}>
        <Form className="calendar-entry-form" labelCol={{ span: 8 }} onFinish={saveEntity} wrapperCol={{ span: 14 }} layout="horizontal">
          <Form.Item label="Jour" name="jour" rules={[{ required: true }]}>
            <Select placeholder="Jour de cours" style={{ width: '100%' }} optionFilterProp="children">
              {JourSemaine.map((jour, i) => (
                <Select.Option key={i} value={i}>
                  {jour}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Heures" rules={[{ required: true }]}>
            <TimePicker.RangePicker
              format="HH:mm"
              allowClear
              showNow={false}
              onChange={handleTimeChange}
              disabledTime={() => {
                const disabledHours = () => {
                  const hours = [];
                  for (let i = 0; i < 24; i++) {
                    if (i < 7 || i > 19) {
                      hours.push(i);
                    }
                  }
                  return hours;
                };

                return {
                  disabledHours,
                };
              }}
              defaultValue={[moment(heureDebut, 'HH:mm'), moment(heureFin, 'HH:mm')]}
            />
          </Form.Item>
          <Form.Item label="Matiere" name={['matiere', 'id']} rules={[{ required: true }]}>
            <Select placeholder="matiere" style={{ width: '100%' }} optionFilterProp="children" showSearch>
              {matieres.map(matiere => (
                <Select.Option key={matiere.id} value={matiere.id}>
                  {' '}
                  {matiere.nom}{' '}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Professeur" rules={[{ required: true }]}>
            <Select
              placeholder="professeurs"
              mode="multiple"
              style={{ width: '100%' }}
              optionFilterProp="children"
              onChange={handleProfesseur}
            >
              {professeurs
                .filter(prof => prof.typePersonnel === 'ENSEIGNANT')
                .map(prof => (
                  <Select.Option key={prof.id} value={prof.id}>
                    {' '}
                    {prof.prenom} {prof.nom}{' '}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Row align="middle">
              <Button data-cy="entityCreateSaveButton" htmlType="submit" id="save-entity" className="save-btn">
                <FontAwesomeIcon icon="save" />
                &nbsp; Enregistrer
              </Button>
              &nbsp;
              <Button key="back" className="cancel-btn" onClick={goBack}>
                Annuler
              </Button>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CalendarEntryCreateModal;
